import { baseApi, extractData } from "../api/axiosConfig";

export const getAllDataPointValues = () =>
    baseApi
        .get("/dataPointValue")
        .then(extractData);

export const addDataPointValue = data =>
    baseApi
        .post("/dataPointValue", data)
        .then(extractData);

export const editDataPointValue = (dataPointValueId, data) =>
    baseApi
        .put(`/dataPointValue/${dataPointValueId}`, data)
        .then(extractData);

export const deleteDataPointValue = dataPointValueId =>
    baseApi
        .delete(`/dataPointValue/${dataPointValueId}`)
        .then(extractData);

export const getDataPointValueByDataPointId = dataPointId =>
    baseApi
        .get("/dataPointValue/dataPointId", {
            params: {
                dataPointId
            }
        })
        .then(extractData);

export const getGuilds = () =>
    baseApi
        .get("/dataPointValue/guild")
        .then(extractData);


//
// export   const addDataPointValue = abcd =>
//     axios.post(`${BASE_URL}/api/contramatic/dataPointValue`,abcd, {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             }
//         })
//     //         params: {data_port_id: abcd.dataPoint.id,
//     //             mcode: abcd.mcode,
//     //             name: abcd.name,
//     //             descrpition: abcd.description
//     //         }
//     //     })
//     // abcd)
//         // <param name="" value="">)
//         .then(function (response) {
//             console.log("here's my data to ADD");
//             console.log({abcd});
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const editDataPointValue = (selectorDataPointValueId, abcd) =>
//     axios.put(`${BASE_URL}/api/contramatic/dataPointValue/${selectorDataPointValueId}`, abcd, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log("here's my id");
//             console.log({selectorDataPointValueId});
//             console.log("here's my abcd");
//             console.log({abcd});
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log("here's my id");
//                 console.log({selectorDataPointValueId});
//                 console.log("here's my abcd error 1");
//                 console.log({abcd});
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log("here's my id");
//                 console.log({selectorDataPointValueId});
//                 console.log("here's my abcd error 2");
//                 console.log({abcd});
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log("here's my id");
//                 console.log({selectorDataPointValueId});
//                 console.log("here's my abcd error 3");
//                 console.log({abcd});
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// //https://www.javatpoint.com/react-axios-delete-request-example except that it shows the wrong kinds of quotes - not backquotes
// export const deleteDataPointValue = selectorDataPointValueId =>
//     axios.delete(`${BASE_URL}/api/contramatic/dataPointValue/${selectorDataPointValueId}`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// // https://stackoverflow.com/questions/48980380/returning-data-from-axios-api#48980526
// export function getDataPointValueByDataPointId(dataPointId) {
//     return     axios.get(`${BASE_URL}/api/contramatic/dataPointValue/dataPointId`
//         ,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 dataPointId: dataPointId
//             }
//         }
//         ).then(response => response.data)
// // .then(console.log("this is my response"))
// // .then(   console.log(data))
// };
//
// export const getGuilds = () =>
//     axios.get(`${BASE_URL}/api/contramatic/dataPointValue/guild`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// //
// // export   const getDataPointValueByDataPointId2 = (dataPointId) =>
// //     axios.get(`${BASE_URL}/api/contramatic/dataPointValue/dataPointId`,
// //         {
// //             params: {
// //                 dataPointId: dataPointId
// //             }
// //         })
// //         //         params: {data_port_id: abcd.dataPoint.id,
// //         //             mcode: abcd.mcode,
// //         //             name: abcd.name,
// //         //             descrpition: abcd.description
// //         //         }
// //         //     })
// //         // abcd)
// //         // <param name="" value="">)
// //         .then(function (response) {
// //             console.log("here's my data to Get");
// //             console.log({dataPointId});
// //             console.log("here's my response");
// //             console.log(response);
// //         })
// //         .catch(function (error) {
// //             if (error.response) {
// //                 // The request was made and the server responded with a status code
// //                 // that falls out of the range of 2xx
// //                 console.log(error.response.data);
// //                 console.log(error.response.status);
// //                 console.log(error.response.headers);
// //             } else if (error.request) {
// //                 // The request was made but no response was received
// //                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
// //                 // http.ClientRequest in node.js
// //                 console.log(error.request);
// //             } else {
// //                 // Something happened in setting up the request that triggered an Error
// //                 console.log('Error', error.message);
// //             }
// //             console.log(error.config);
// //
// //         });
// //
